var React = require('react');

function IconFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.3333 7.5C14.3333 4.05 11.3467 1.25 7.66667 1.25C3.98667 1.25 1 4.05 1 7.5C1 10.525 3.29333 13.0437 6.33333 13.625V9.375H5V7.5H6.33333V5.9375C6.33333 4.73125 7.38 3.75 8.66667 3.75H10.3333V5.625H9C8.63333 5.625 8.33333 5.90625 8.33333 6.25V7.5H10.3333V9.375H8.33333V13.7188C11.7 13.4063 14.3333 10.7438 14.3333 7.5Z","fill":"white"}));
}

IconFacebook.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = IconFacebook;

IconFacebook.default = IconFacebook;
